import { message } from "antd";
import { API } from "../../../helpers/API/amplifyApi";
import moment from "moment-timezone";
import dayjsTZ, { dayjsInTz } from "../../../utils/dayjs";
import { dayCalculateFactory } from "../../../components/Pagat/PaySub/employeeCalc/dayCalculateFactory";
import { requestData } from "../../../helpers/API/RequestFactory";
import { buildClockingEmployeeSnapshot } from "../../../utils/clockingEmployeeSnapshot";
/**
 * Retrieves all the valid, (not Ongoin shifts)
 * for specific employee and sorts them according to clockIn timestamp (/ms)
 * @param {String} employeeId the identifier for employee
 * @returns {Array} Array of Objects if successful & nonEmpty or empty Array if error occured
 */
export const getValidShifts = async (employeeId) => {
  return await requestData("clocking", { employeeId }).then(
    (success) =>
      success
        .filter((el) => el.clockOutDate !== null)
        .sort((a, b) => a.clockInDate - b.clockInDate),
    (err) => console.error("error", err)
  );
};

// Without Null Filter
export const getShifts = async (employeeId) => {
  return await requestData("clocking", { employeeId }).then(
    (success) => success.sort((a, b) => a.createdAt - b.createdAt),
    (err) => console.error("error", err)
  );
  // return await API.get("clocking", "/clocking").then(
  // 	(success) =>
  // 		success
  // 			.filter((el) => el.employeeId === employeeId)
  // 			.sort((a, b) => a.createdAt - b.createdAt),
  // 	(err) => console.error("error", err)
  // );
};

/**
 * From all shifts, sorted for a specific Employee ID, it returns the last ongoing shift
 * @param {Array} Array of objects filteredShifts
 * @returns {Object} with shift values for clockOutDate === null
 */

export const getLastOnGoingShift = (filteredShifts) => {
  if (!Array.isArray(filteredShifts) || filteredShifts.length === 0) {
    return null;
  }
  // Prefer the latest open shift anywhere in the list — not only when it
  // happens to be the last array element (newer closed rows can trail it).
  const open = filteredShifts
    .filter((el) => el != null && (el.clockOutDate == null || el.clockOutDate === ""))
    .sort((a, b) => (a.clockInDate || 0) - (b.clockInDate || 0));
  return open.length ? open[open.length - 1] : null;
};

/**
 * Starts the shift for specific user with clockOutDate = null
 * @param {Object} shift initial Shift Values
 * @param {moment} value of clockIn
 * @returns {Promise} with sucess/error status
 */
export const startClockIn = async (shift, val) => {
  if ((await validateNotPrevClockIn(val, shift.employeeId)) !== false) {
    let fixedTime = dayjsTZ(val);
    fixedTime = fixedTime
      .set("hour", fixedTime.get("hour"))
      .set("minute", fixedTime.get("minute"))
      .set("second", "00");

    const employeeSnapshot = shift?.employee
      ? buildClockingEmployeeSnapshot(shift.employee)
      : buildClockingEmployeeSnapshot(shift);
    return await API.post("clocking", `/clocking`, {
      body: {
        ...employeeSnapshot,
        ...shift,
        clockInDate: dayjsTZ(fixedTime).valueOf(),
      },
    }).then(
      (res) => console.log("Clock In", res),
      (err) => console.log("error", err)
    );
  } else {
    return Promise.reject("Perplasje oraresh!");
  }
};

/**
 * Ends the specific shift, which ID attribute is given on call,
 * And updates the clockOutDate with current timestamp in milliseconds
 * @param {String} lastShift the ID of the shift which will be updated/finished
 * @returns {Promise} with sucess/error status
 */
export const endShift = async (lastShift, shift, time) => {
  console.log("lastShift", lastShift, "shift", shift, "time", time);

  if (!lastShift?.clockingId) {
    throw new Error("missing_clocking_id");
  }

  const tz = shift?.timezone || lastShift?.timezone;
  const d = (v) => (tz ? dayjsInTz(tz, v) : dayjsTZ(v));

  let fixedTime = d(time);
  if (!fixedTime?.isValid?.()) {
    throw new Error("invalid_clock_out_time");
  }
  fixedTime = fixedTime
    .set("hour", fixedTime.get("hour"))
    .set("minute", fixedTime.get("minute"))
    .set("second", "00");

  const timezone = tz || undefined;
  // Totals are best-effort — never block closing an open shift if payroll
  // helpers fail (network / programFields / etc.).
  let amounts = {};
  try {
    amounts =
      (await dayCalculateFactory({
        ...shift,
        employeeId: shift?.employeeId || lastShift?.employeeId,
        clockingId: lastShift?.clockingId,
        timezone,
        clockInDate: lastShift?.clockInDate,
        clockOutDate: fixedTime.valueOf(),
      })) || {};
  } catch (calcErr) {
    console.error("[endShift] dayCalculateFactory failed:", calcErr);
  }

  const res = await API.put("clocking", `/clocking/${lastShift.clockingId}`, {
    body: {
      ...shift,
      timezone,
      clockingLogs: lastShift?.clockingLogs || [],
      clockOutDate: fixedTime.valueOf(),
      totalities: amounts || {},
    },
  });
  if (res?.status === false) {
    throw new Error(res?.error || "clock_out_update_failed");
  }
  return res;
};

export const validateNotPrevClockIn = async (timeInstance, emplId) => {
  let val = dayjsTZ(timeInstance).valueOf();
  // Prefer Redux clockings (already month-scoped) to avoid another API round-trip.
  let fromStore = [];
  try {
    const { store } = await import("../../../store/store");
    const all = store.getState()?.clockings?.clockings;
    if (Array.isArray(all)) {
      fromStore = all.filter((el) => el?.employeeId === emplId);
    }
  } catch (_e) {
    fromStore = [];
  }
  let shifts = fromStore.length > 0 ? fromStore : await getShifts(emplId);

  if (shifts.length > 0) {
    let error = shifts.filter((el) => el.clockOutDate > val);
    if (error.length > 0) {
      message.error("Turni juaj nuk mund te fijohët.");
      return false;
    } else {
      return true;
    }
  }
};

export const endDoubleShift = async (lastShift, shift, time) => {
  // Prefer clocking/team timezone snapshot when present; else legacy dayjsTZ.
  const tz = shift?.timezone || lastShift?.timezone;
  const d = (v) => (tz ? dayjsInTz(tz, v) : dayjsTZ(v));

  let endOfFirst = d(lastShift?.clockInDate)
    .hour(23)
    .minute(59)
    .second(59);

  // Next calendar day in the same zone (was missing +1 day before).
  let startOfSecond = d(lastShift?.clockInDate)
    .add(1, "day")
    .hour(0)
    .minute(0)
    .second(0);

  const out = d(time);
  let endOfShift = d(lastShift?.clockInDate)
    .add(1, "day")
    .hour(out.hour())
    .minute(out.minute())
    .second(out.second() + 1);

  const timezone = tz || undefined;

  let amounts = {};
  try {
    amounts =
      (await dayCalculateFactory({
        ...shift,
        employeeId: shift?.employeeId || lastShift?.employeeId,
        clockingId: lastShift?.clockingId,
        timezone,
        clockInDate: d(lastShift?.clockInDate).valueOf(),
        clockOutDate: endOfFirst.valueOf(),
      })) || {};
  } catch (calcErr) {
    console.error("[endDoubleShift] dayCalculateFactory failed:", calcErr);
  }
  return await API.put("clocking", `/clocking/${lastShift?.clockingId}`, {
    body: {
      ...shift,
      timezone,
      clockOutDate: endOfFirst.valueOf(),
      totalities: amounts || {},
      slicedShift: true,
    },
  }).then(async () => {
    let amounts2 = await dayCalculateFactory({
      ...shift,
      timezone,
      clockInDate: startOfSecond.valueOf(),
      clockOutDate: endOfShift.valueOf(),
    });
    return await API.post("clocking", `/clocking`, {
      body: {
        ...lastShift,
        timezone,
        clockInNote: "",
        totalities: amounts2 || {},
        clockInDate: startOfSecond.valueOf(),
        clockOutDate: endOfShift.valueOf(),
        clockingCategory: "midnightReset",
      },
    });
  });
};
